// import React, { useState, useEffect, useRef } from "react";
// import { useLocation, useNavigate } from "react-router-dom";
// import {
//   Grid,
//   TextField,
//   Button,
//   Typography,
//   Box,
//   MenuItem,
// } from "@mui/material";
// import axios from "axios";
// import SaudaBookUtilityHelp from "../../../Helper/SaudaBookUtilityHelp";
// import AccountMasterHelp from "../../../Helper/AccountMasterHelp";
// import Swal from "sweetalert2";
// import BackButton from "../../../Common/Buttons/BackButton";

// const API_URL = process.env.REACT_APP_API;

// const SaudaBookUtility = () => {
//   const companyCode = sessionStorage.getItem("Company_Code");
//   const yearCode = sessionStorage.getItem("Year_Code");
//   const location = useLocation();
//   const tenderData = location.state?.tenderData;
//   const buyerRef = useRef();
//   const navigate = useNavigate();


//   const initialFormState = {
//     Tender_No: "",
//     ID: "",
//     Delivery_Type: "C",
//     Buyer: "",
//     ShipTo: "",
//     Buyer_Party: "",
//     sub_broker: "",
//     buyerid: "",
//     buyerpartyid: "",
//     sbr: "",
//     shiptoid: "",
//     Buyer_Quantal: "",
//     Sale_Rate: "",
//     Commission_Rate: "",
//     Sauda_Date: new Date().toISOString().split("T")[0],
//     Lifting_Date: new Date().toISOString().split("T")[0],
//     Narration: "",
//     tcs_rate: 0.0,
//     gst_rate: 5.0,
//     tcs_amt: 0.0,
//     gst_amt: 0.0,
//     tenderid: "",
//     tenderdetailid: null,
//   };

//   const [formData, setFormData] = useState(initialFormState);

//   const [netAmount, setNetAmount] = useState("0.00");
//   const [millCode, setMillCode] = useState("");
//   const [millId, setMillId] = useState("");
//   const [millName, setMillName] = useState("");
//   const [buyerName, setBuyerName] = useState("");
//   const [shipToName, setShipToName] = useState("");
//   const [brokerName, setBrokerName] = useState("");
//   const [subBrokerName, setSubBrokerName] = useState("");
//   const [tenderDisplayText, setTenderDisplayText] = useState("");
// const [isSubmitting, setIsSubmitting] = useState(false);

//   useEffect(() => {
//     if (tenderData) {
//       setMillCode(tenderData.Mill_Code || "");
//       setMillName(tenderData.millshortname || "");
//       setMillId(tenderData.mc || "");
//       setFormData((prev) => ({
//         ...prev,
//         Tender_No: tenderData.Tender_No || "",
//         tenderid: tenderData.tenderid || "",
//         Lifting_Date: tenderData.payment_date || new Date().toISOString().split("T")[0],
//         Narration: tenderData.Grade || "",
//       }));

//       const displayText = `Balance:${tenderData.BALANCE || "0.00"} Grade:${tenderData.Grade || ""} Mill Rate:${tenderData.Mill_Rate || ""} Tender Date:${tenderData.Tender_Date || ""} `;
//       setTenderDisplayText(displayText);
//     }
//     setTimeout(() => {
//       if (buyerRef.current) {
//         buyerRef.current.focus();
//       }
//     }, 100);
//   }, [tenderData]);


//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prev) => ({ ...prev, [name]: value }));
//   };

//   const handleMillCode = (code, accoid, name) => {
//     setMillCode(code);
//     setMillId(accoid);
//     setMillName(name);
//   };

//   const handleTenderSelection = (item) => {
//     setFormData((prev) => ({
//       ...prev,
//       Tender_No: item.Tender_No || "",
//       ID: item.ID || "",
//       Delivery_Type: "C",
//       tenderid: item.tenderid || "",
//       // Sale_Rate: item.Mill_Rate || "",
//       Lifting_Date: new Date().toISOString().split("T")[0],
//       Narration: item.Grade || "",
//     }));

//     const display = `Balance:${item.balance || "0.00"} Season:${item.season || ""} Grade:${item.Grade || ""
//       } Lifting Date:${item.Lifting_Date || ""} Mill Rate:${item.Mill_Rate || ""} Purchase rate${item.Purc_Rate || ""
//       }`;
//     setTenderDisplayText(display);
//   };

//   const handleAccountSelect =
//     (field, idField) => (code, accoid, selectedName) => {
//       setFormData((prev) => ({
//         ...prev,
//         [field]: code,
//         [idField]: accoid,
//         ...(field === "Buyer" && {
//           ShipTo: code,
//           shiptoid: accoid,
//           Buyer_Party: 2,
//           sub_broker: 2,
//           buyerpartyid: 2,
//           sbr: 2
//         }),
//       }));

//       if (field === "Buyer") {
//         setBuyerName(selectedName);
//         setShipToName(selectedName);
//         setBrokerName("SELF");
//         setSubBrokerName("SELF");

//         setTimeout(() => {
//           const qtyInput = document.querySelector('input[name="Buyer_Quantal"]');
//           if (qtyInput) qtyInput.focus();
//         }, 100);

//       } else if (field === "millCode") {
//         setMillName(selectedName);
//       } else if (field === "ShipTo") {
//         setShipToName(selectedName);
//       } else if (field === "Buyer_Party") {
//         setBrokerName(selectedName);
//       } else if (field === "sub_broker") {
//         setSubBrokerName(selectedName);
//       }
//     };


//   useEffect(() => {
//     const qty = parseFloat(formData.Buyer_Quantal) || 0;
//     const rate = parseFloat(formData.Sale_Rate) || 0;
//     const gstRate = parseFloat(formData.gst_rate) || 0;
//     const tcsRate = parseFloat(formData.tcs_rate) || 0;

//     const baseAmount = qty * rate;
//     const gstAmt = (baseAmount * gstRate) / 100;
//     const tcsAmt = (baseAmount * tcsRate) / 100;
//     const netAmt = baseAmount + gstAmt + tcsAmt;

//     setFormData((prev) => ({
//       ...prev,
//       gst_amt: gstAmt.toFixed(2),
//       tcs_amt: tcsAmt.toFixed(2),
//     }));
//     setNetAmount(netAmt.toFixed(2));
//   }, [
//     formData.Buyer_Quantal,
//     formData.Sale_Rate,
//     formData.gst_rate,
//     formData.tcs_rate,
//   ]);

//   // const handleSubmit = async () => {
//   //   try {
//   //     await axios.post(`${API_URL}/add_tender_detail`, {
//   //       detailData: {
//   //         ...formData,
//   //         Commission_Rate: parseFloat(formData.Commission_Rate) || 0.0,
//   //         Buyer_Quantal: parseFloat(formData.Buyer_Quantal) || 0.0,
//   //         Sale_Rate: parseFloat(formData.Sale_Rate) || 0.0,
//   //         tcs_amt: parseFloat(formData.tcs_amt) || 0.0,
//   //         gst_amt: parseFloat(formData.gst_amt) || 0.0,
//   //         tcs_rate: parseFloat(formData.tcs_rate) || 0.0,
//   //         gst_rate: parseFloat(formData.gst_rate) || 0.0,
//   //         Company_Code: companyCode,
//   //         year_code: yearCode,
//   //       },
//   //     });
//   //     Swal.fire({
//   //       title: "Success!",
//   //       text: "Sauda Updated Successfully!",
//   //       icon: "success",
//   //       confirmButtonText: "OK"
//   //     });
//   //     setFormData(initialFormState);
//   //     setNetAmount("0.00");
//   //     setMillCode("");
//   //     setMillId("");
//   //     setMillName("");
//   //     setBuyerName("");
//   //     setShipToName("");
//   //     setBrokerName("");
//   //     setSubBrokerName("");
//   //     setTenderDisplayText("");
//   //     setTimeout(() => {
//   //       navigate("/sauda-book-utility-page", { replace: true, state: null });
//   //     }, 1000);

//   //   } catch (error) {
//   //     console.error("Error submitting form:", error);
//   //     alert("Failed to save Sauda detail");
//   //   }
//   // };

//   const handleSubmit = async () => {
//   if (isSubmitting) return; // prevents double-click
//   setIsSubmitting(true);

//   try {
//     const commission = parseFloat(formData.Commission_Rate) || 0;

//     // Case 1: Negative commission
//     if (commission < 0) {
//       const result = await Swal.fire({
//         title: "Negative Commission Rate",
//         text: "The Commission Rate entered is negative. Do you still want to save this record?",
//         icon: "warning",
//         showCancelButton: true,
//         confirmButtonText: "Yes, Save",
//         cancelButtonText: "No, Correct It",
//       });

//       if (!result.isConfirmed) {
//         await Swal.fire("Action Required", "Please correct the Commission Rate before saving.", "info");
//         setIsSubmitting(false);
//         return;
//       }
//     }

//     // Case 2: Non-zero positive commission
//     else if (commission > 0) {
//       const confirmApply = await Swal.fire({
//         title: "Confirm Commission Rate",
//         text: `You entered a Commission Rate of ${commission}. Is this correct?`,
//         icon: "question",
//         showCancelButton: true,
//         confirmButtonText: "Yes, It's Correct",
//         cancelButtonText: "No, Change It",
//       });

//       if (!confirmApply.isConfirmed) {
//         const resetConfirm = await Swal.fire({
//           title: "Set Commission Rate to 0?",
//           text: "Would you like to set the Commission Rate to 0 and save automatically?",
//           icon: "warning",
//           showCancelButton: true,
//           confirmButtonText: "Yes, Set to 0 and Save",
//           cancelButtonText: "No, I'll Correct Manually",
//         });

//         if (resetConfirm.isConfirmed) {
//           formData.Commission_Rate = 0;

//           await Swal.fire({
//             title: "Commission Reset",
//             text: "Commission Rate has been set to 0. Record will now be saved automatically.",
//             icon: "success",
//             timer: 1200,
//             showConfirmButton: false,
//           });

//           await saveTenderDetail(0); // Auto-save
//           setIsSubmitting(false);
//           return;
//         } else {
//           await Swal.fire("Action Required", "Please correct the Commission Rate manually before saving.", "info");
//           setIsSubmitting(false);
//           return;
//         }
//       }
//     }

//     // Proceed normally (either 0 or confirmed)
//     await saveTenderDetail(commission);
//   } catch (error) {
//     console.error("Error submitting form:", error);
//     Swal.fire("Error", "Failed to save Sauda detail", "error");
//   } finally {
//     setIsSubmitting(false);
//   }
// };

// // Separate reusable save function
// const saveTenderDetail = async (commissionValue) => {
//   await axios.post(`${API_URL}/add_tender_detail`, {
//     detailData: {
//       ...formData,
//       Commission_Rate: commissionValue,
//       Buyer_Quantal: parseFloat(formData.Buyer_Quantal) || 0.0,
//       Sale_Rate: parseFloat(formData.Sale_Rate) || 0.0,
//       tcs_amt: parseFloat(formData.tcs_amt) || 0.0,
//       gst_amt: parseFloat(formData.gst_amt) || 0.0,
//       tcs_rate: parseFloat(formData.tcs_rate) || 0.0,
//       gst_rate: parseFloat(formData.gst_rate) || 0.0,
//       Company_Code: companyCode,
//       year_code: yearCode,
//     },
//   });

//   await Swal.fire("Success!", "Sauda Updated Successfully!", "success");
//   resetFormAndNavigate();
// };

// // Reset after success
// const resetFormAndNavigate = () => {
//   setFormData(initialFormState);
//   setNetAmount("0.00");
//   setMillCode("");
//   setMillId("");
//   setMillName("");
//   setBuyerName("");
//   setShipToName("");
//   setBrokerName("");
//   setSubBrokerName("");
//   setTenderDisplayText("");
//   setTimeout(() => {
//     navigate("/sauda-book-utility-page", { replace: true, state: null });
//   }, 1000);
// };

//   const handleBack = () => {
//     navigate("/sauda-book-utility-page");
//   };

//   return (
//     <>
//       <Box
//         minHeight="100vh"
//         display="flex"
//         justifyContent="center"
//         alignItems="start"
//         pt={4}
//         bgcolor="#f5f5f5"
//       >
//         <Box mr={2} mt={1}>
//           <BackButton onClick={handleBack} />
//         </Box>
//         <Box
//           width="800px"
//           bgcolor="white"
//           p={3}
//           borderRadius={2}
//           boxShadow={2}
//         >
//           <Typography
//             variant="h6"
//             align="center"
//             gutterBottom
//             sx={{
//               color: "black",
//               fontWeight: 'bold',
//               mb: 1
//             }}
//           >
//             Sauda Book Utility
//           </Typography>


//           <Grid container spacing={0.5} >

//             <Grid item xs={12} sm={4} display="flex" alignItems="center">
//               <Typography fontWeight="bold">Mill Code :</Typography>
//             </Grid>
//             <Grid item xs={12} sm={8}>
//               <AccountMasterHelp
//                 name="Mill_Code"
//                 CategoryCode={millCode}
//                 CategoryName={millName}
//                 onAcCodeClick={handleMillCode}
//               />
//             </Grid>

//             <Grid item xs={12} sm={4} display="flex" alignItems="center">
//               <Typography fontWeight="bold">Tender No :</Typography>
//             </Grid>
//             <Grid item xs={12} sm={8} >
//               <Box display="flex" alignItems="center" ml={1}>
//                 <SaudaBookUtilityHelp
//                   name="tender_no"
//                   Millcode={millCode}
//                   Tenderno={formData.Tender_No}
//                   Tenderid={formData.tenderid}
//                   onRecordDoubleClick={handleTenderSelection}
//                 />
//                 <Typography
//                   variant="body2"
//                   sx={{
//                     color: "#0056b3",
//                     fontWeight: 600,
//                     fontSize: "13px",
//                     whiteSpace: "nowrap",
//                     overflow: "hidden",
//                     textOverflow: "ellipsis",
//                     flex: 1
//                   }}
//                 >
//                   {tenderDisplayText}
//                 </Typography>
//               </Box>
//             </Grid>

//             {[
//               {
//                 label: "Bill To :", name: "Buyer", component: (
//                   <AccountMasterHelp
//                     name="Buyer"
//                     CategoryCode={formData.Buyer}
//                     CategoryName={buyerName}
//                     onAcCodeClick={handleAccountSelect("Buyer", "buyerid")}
//                     firstInputRef={buyerRef}
//                   />
//                 )
//               },
//               {
//                 label: "Ship To :", name: "ShipTo", component: (
//                   <AccountMasterHelp
//                     name="ShipTo"
//                     CategoryCode={formData.ShipTo}
//                     CategoryName={shipToName}
//                     onAcCodeClick={handleAccountSelect("ShipTo", "shiptoid")}
//                   />
//                 )
//               },
//               {
//                 label: "Delivery Type :", name: "Delivery_Type", component: (
//                   <TextField
//                     select
//                     size="small"
//                     fullWidth
//                     name="Delivery_Type"
//                     value={formData.Delivery_Type}
//                     onChange={handleInputChange}
//                     sx={{
//                       '& .MuiInputBase-root': {
//                         height: '40px',
//                         fontSize: '14px',
//                         width: '26%',
//                         marginLeft: '10px',
//                       },
//                       '& .MuiMenuItem-root': {
//                         fontSize: '14px'
//                       }
//                     }}
//                   >
//                     <MenuItem value="N">With GST Naka Delivery</MenuItem>
//                     <MenuItem value="A">Naka Delivery without GST Rate</MenuItem>
//                     <MenuItem value="C">Commission</MenuItem>
//                     <MenuItem value="D">DO</MenuItem>
//                   </TextField>
//                 )
//               },
//               {
//                 label: "Broker :", name: "Buyer_Party", component: (
//                   <AccountMasterHelp
//                     name="Buyer_Party"
//                     CategoryCode={formData.Buyer_Party}
//                     CategoryName={brokerName}
//                     onAcCodeClick={handleAccountSelect("Buyer_Party", "buyerpartyid")}
//                   />
//                 )
//               },
//               {
//                 label: "Sub Broker :", name: "sub_broker", component: (
//                   <AccountMasterHelp
//                     name="sub_broker"
//                     CategoryCode={formData.sub_broker}
//                     CategoryName={subBrokerName}
//                     onAcCodeClick={handleAccountSelect("sub_broker", "sbr")}
//                   />
//                 )
//               },
//               {
//                 label: "Buyer Quintal :", name: "Buyer_Quantal", component: (
//                   <TextField
//                     size="small"
//                     fullWidth
//                     type="number"
//                     name="Buyer_Quantal"
//                     autoComplete="off"
//                     value={formData.Buyer_Quantal}
//                     onChange={handleInputChange}
//                   />
//                 )
//               },
//               {
//                 label: "Sale Rate :", name: "Sale_Rate", component: (
//                   <TextField
//                     size="small"
//                     type="number"
//                     fullWidth
//                     name="Sale_Rate"
//                     autoComplete="off"
//                     value={formData.Sale_Rate}
//                     onChange={handleInputChange}
//                   />
//                 )
//               },
//               {
//                 label: "Commission :", name: "Commission_Rate", component: (
//                   <TextField
//                     size="small"
//                     type="number"
//                     fullWidth
//                     autoComplete="off"
//                     name="Commission_Rate"
//                     value={formData.Commission_Rate}
//                     onChange={handleInputChange}
//                     disabled
//                   />
//                 )
//               },
//               {
//                 label: "Dates :",
//                 component: (
//                   <Box display="flex" gap={2} alignItems="center">
//                     <Box flex={1} mt={0.5}>
//                       <TextField
//                         type="date"
//                         size="small"
//                         fullWidth
//                         name="Sauda_Date"
//                         label="Sauda Date"
//                         value={formData.Sauda_Date}
//                         onChange={handleInputChange}
//                         InputLabelProps={{ shrink: true }}
//                       />
//                     </Box>
//                     <Box flex={1} mt={0.5}>
//                       <TextField
//                         type="date"
//                         size="small"
//                         fullWidth
//                         name="Lifting_Date"
//                         label="Payment Date"
//                         value={formData.Lifting_Date}
//                         onChange={handleInputChange}
//                         InputLabelProps={{ shrink: true }}
//                       />
//                     </Box>
//                   </Box>
//                 )
//               },
//               {
//                 label: "Narration :", name: "Narration", component: (
//                   <TextField
//                     size="small"
//                     fullWidth
//                     name="Narration"
//                     value={formData.Narration}
//                     onChange={handleInputChange}
//                     multiline
//                     rows={2}
//                   />
//                 )
//               },
//             ].map((item, index) => (
//               <React.Fragment key={item.name}>
//                 <Grid item xs={12} sm={4} display="flex" alignItems="center">
//                   <Typography fontWeight="bold">{item.label}</Typography>
//                 </Grid>
//                 <Grid item xs={12} sm={8}>
//                   {item.component}
//                 </Grid>
//               </React.Fragment>
//             ))}

//             <Grid item xs={12} sm={4} display="flex" alignItems="center">
//               <Typography fontWeight="bold">GST Amount :</Typography>
//             </Grid>
//             <Grid item xs={6} sm={4} mt={1}>
//               <TextField
//                 label="GST Rate"
//                 type="number"
//                 autoCapitalize="off"
//                 size="small"
//                 fullWidth
//                 name="gst_rate"
//                 value={formData.gst_rate}
//                 onChange={handleInputChange}
//               />
//             </Grid>
//             <Grid item xs={6} sm={4} mt={1}>
//               <TextField
//                 label="GST Amount"
//                 type="number"
//                 autoCapitalize="off"
//                 size="small"
//                 fullWidth
//                 value={formData.gst_amt}
//                 InputProps={{ readOnly: true }}
//               />
//             </Grid>

//             <Grid item xs={12} sm={4} display="flex" alignItems="center">
//               <Typography fontWeight="bold">TCS Amount :</Typography>
//             </Grid>
//             <Grid item xs={6} sm={4} mt={1}>
//               <TextField
//                 label="TCS Rate"
//                 type="number"
//                 autoCapitalize="off"
//                 size="small"
//                 fullWidth
//                 name="tcs_rate"
//                 value={formData.tcs_rate}
//                 onChange={handleInputChange}
//               />
//             </Grid>
//             <Grid item xs={6} sm={4} mt={1}>
//               <TextField
//                 label="TCS Amount"
//                 type="number"
//                 autoCapitalize="off"
//                 size="small"
//                 fullWidth
//                 value={formData.tcs_amt}
//                 InputProps={{ readOnly: true }}
//               />
//             </Grid>

//             <Grid item xs={12} sm={4} display="flex" alignItems="center">
//               <Typography fontWeight="bold">Net Amount :</Typography>
//             </Grid>
//             <Grid item xs={12} sm={8}>
//               <TextField
//                 size="small"
//                 type="number"
//                 autoCapitalize="off"
//                 fullWidth
//                 value={netAmount}
//                 InputProps={{
//                   readOnly: true,
//                   sx: { fontWeight: 'bold', fontSize: '1rem' }
//                 }}
//               />
//             </Grid>

//          <Grid item xs={12} sx={{ mt: 2 }}>
//   <Button
//     variant="contained"
//     fullWidth
//     onClick={handleSubmit}
//     disabled={isSubmitting} // ✅ disable while saving
//     sx={{
//       width: '150px',
//       height: '36px',
//       fontSize: '0.875rem',
//       fontWeight: 'bold',
//       padding: '6px 12px',
//       backgroundColor: isSubmitting ? '#9e9e9e' : undefined, // ✅ grey-out while saving
//       cursor: isSubmitting ? 'not-allowed' : 'pointer',
//     }}
//   >
//     {isSubmitting ? 'Saving...' : 'Update'}
//   </Button>
// </Grid>

//           </Grid>
//         </Box>
//       </Box>
//     </>
//   );
// };

// export default SaudaBookUtility;


import React, { useState, useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  Grid,
  TextField,
  Button,
  Typography,
  Box,
  MenuItem,
} from "@mui/material";
import axios from "axios";
import SaudaBookUtilityHelp from "../../../Helper/SaudaBookUtilityHelp";
import AccountMasterHelp from "../../../Helper/AccountMasterHelp";
import Swal from "sweetalert2";
import BackButton from "../../../Common/Buttons/BackButton";

const API_URL = process.env.REACT_APP_API;

const SaudaBookUtility = () => {
  const companyCode = sessionStorage.getItem("Company_Code");
  const yearCode = sessionStorage.getItem("Year_Code");
  const location = useLocation();
  const tenderData = location.state?.tenderData;
  const buyerRef = useRef();
  const navigate = useNavigate();

  const initialFormState = {
    Tender_No: "",
    ID: "",
    Delivery_Type: "C",
    Buyer: "",
    ShipTo: "",
    Buyer_Party: "",
    sub_broker: "",
    buyerid: "",
    buyerpartyid: "",
    sbr: "",
    shiptoid: "",
    Buyer_Quantal: "",
    Sale_Rate: "",
    Commission_Rate: "",
    Sauda_Date: new Date().toISOString().split("T")[0],
    Lifting_Date: new Date().toISOString().split("T")[0],
    Narration: "",
    tcs_rate: 0.0,
    gst_rate: 5.0,
    tcs_amt: 0.0,
    gst_amt: 0.0,
    tenderid: "",
    tenderdetailid: null,
  };

  const [formData, setFormData] = useState(initialFormState);
  const [netAmount, setNetAmount] = useState("0.00");
  const [millCode, setMillCode] = useState("");
  const [millId, setMillId] = useState("");
  const [millName, setMillName] = useState("");
  const [buyerName, setBuyerName] = useState("");
  const [shipToName, setShipToName] = useState("");
  const [brokerName, setBrokerName] = useState("");
  const [subBrokerName, setSubBrokerName] = useState("");
  const [tenderDisplayText, setTenderDisplayText] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [shouldFocusBuyer, setShouldFocusBuyer] = useState(false);

  // Initialize form with tender data when component mounts or tenderData changes
  useEffect(() => {
    if (tenderData) {
      const newMillCode = tenderData.Mill_Code || "";
      const newMillName = tenderData.millshortname || "";
      const newMillId = tenderData.mc || "";

      setMillCode(newMillCode);
      setMillName(newMillName);
      setMillId(newMillId);

      setFormData((prev) => ({
        ...prev,
        Tender_No: tenderData.Tender_No || "",
        tenderid: tenderData.tenderid || "",
        Lifting_Date: tenderData.payment_date || new Date().toISOString().split("T")[0],
        Narration: tenderData.Grade || "",
      }));

      const displayText = `Balance:${tenderData.BALANCE || "0.00"} Grade:${tenderData.Grade || ""} Mill Rate:${tenderData.Mill_Rate || ""} Tender Date:${tenderData.Tender_Date || ""} `;
      setTenderDisplayText(displayText);

      // Set flag to focus buyer field
      setShouldFocusBuyer(true);
    }
  }, [tenderData]);

  // Focus management - separate useEffect for focus
  useEffect(() => {
    if (shouldFocusBuyer && buyerRef.current) {
      buyerRef.current.focus();
      setShouldFocusBuyer(false);
    }
  }, [shouldFocusBuyer]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleMillCode = (code, accoid, name) => {
    setMillCode(code);
    setMillId(accoid);
    setMillName(name);
    // When mill code changes, reset tender related data
    setFormData(prev => ({
      ...prev,
      Tender_No: "",
      tenderid: "",
      Narration: "",
    }));
    setTenderDisplayText("");
    setShouldFocusBuyer(true);
  };

  const handleTenderSelection = (item) => {
    setFormData((prev) => ({
      ...prev,
      Tender_No: item.Tender_No || "",
      ID: item.ID || "",
      Delivery_Type: "C",
      tenderid: item.tenderid || "",
      Lifting_Date: new Date().toISOString().split("T")[0],
      Narration: item.Grade || "",
    }));

    const display = `Balance:${item.balance || "0.00"} Season:${item.season || ""} Grade:${item.Grade || ""
      } Lifting Date:${item.Lifting_Date || ""} Mill Rate:${item.Mill_Rate || ""} Purchase rate${item.Purc_Rate || ""
      }`;
    setTenderDisplayText(display);

    // Focus buyer field after tender selection
    setShouldFocusBuyer(true);
  };

  const handleAccountSelect =
    (field, idField) => (code, accoid, selectedName) => {
      setFormData((prev) => ({
        ...prev,
        [field]: code,
        [idField]: accoid,
        ...(field === "Buyer" && {
          ShipTo: code,
          shiptoid: accoid,
          Buyer_Party: 2,
          sub_broker: 2,
          buyerpartyid: 2,
          sbr: 2
        }),
      }));

      if (field === "Buyer") {
        setBuyerName(selectedName);
        setShipToName(selectedName);
        setBrokerName("SELF");
        setSubBrokerName("SELF");

        setTimeout(() => {
          const qtyInput = document.querySelector('input[name="Buyer_Quantal"]');
          if (qtyInput) qtyInput.focus();
        }, 100);

      } else if (field === "millCode") {
        setMillName(selectedName);
      } else if (field === "ShipTo") {
        setShipToName(selectedName);
      } else if (field === "Buyer_Party") {
        setBrokerName(selectedName);
      } else if (field === "sub_broker") {
        setSubBrokerName(selectedName);
      }
    };

  useEffect(() => {
    const qty = parseFloat(formData.Buyer_Quantal) || 0;
    const rate = parseFloat(formData.Sale_Rate) || 0;
    const gstRate = parseFloat(formData.gst_rate) || 0;
    const tcsRate = parseFloat(formData.tcs_rate) || 0;

    const baseAmount = qty * rate;
    const gstAmt = (baseAmount * gstRate) / 100;
    const tcsAmt = (baseAmount * tcsRate) / 100;
    const netAmt = baseAmount + gstAmt + tcsAmt;

    setFormData((prev) => ({
      ...prev,
      gst_amt: gstAmt.toFixed(2),
      tcs_amt: tcsAmt.toFixed(2),
    }));
    setNetAmount(netAmt.toFixed(2));
  }, [
    formData.Buyer_Quantal,
    formData.Sale_Rate,
    formData.gst_rate,
    formData.tcs_rate,
  ]);

  const handleSubmit = async () => {
    if (isSubmitting) return;
    setIsSubmitting(true);

    try {
      // const saleRate = parseFloat(formData.Sale_Rate);
      // if (!saleRate || saleRate <= 0) {
      //   await Swal.fire({
      //     title: "Sale Rate Required",
      //     text: "Sale Rate is mandatory and must be greater than 0.",
      //     icon: "warning",
      //     confirmButtonText: "OK"
      //   });
      //   setIsSubmitting(false);
      //   return;
      // }

      const { Sale_Rate, Buyer_Quantal} = formData;
      
          let missingFields = [];
          let invalidFields = [];
      
          if (!formData.Buyer) missingFields.push("Bill To");
          if (!formData.ShipTo) missingFields.push("Ship To");
          if (!formData.Buyer_Party) missingFields.push("Broker");
          if (!formData.sub_broker) missingFields.push("Sub Broker");
          
      
          if (Sale_Rate <= 0 || Buyer_Quantal <= 0) {
            if (Sale_Rate <= 0) invalidFields.push("Sale Rate");
            if (Buyer_Quantal <= 0) invalidFields.push("Buyer Quintal");
          }
      
          if (missingFields.length > 0) {
            Swal.fire({
              title: "Warning",
              text: `Please select the following fields. : ${missingFields.join(", ")}`,
              icon: "warning",
              confirmButtonText: "OK"
            });
            setIsSubmitting(false);
            return;
          }
      
          if (invalidFields.length > 0) {
            Swal.fire({
              title: "Warning",
              text: `Please select the following fields. : ${invalidFields.join(", ")}`,
              icon: "warning",
              confirmButtonText: "OK"
            });
            setIsSubmitting(false);
            return;
          }
      
      const commission = parseFloat(formData.Commission_Rate) || 0;

      // Case 1: Negative commission
      if (commission < 0) {
        const result = await Swal.fire({
          title: "Negative Commission Rate",
          text: "The Commission Rate entered is negative. Do you still want to save this record?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes, Save",
          cancelButtonText: "No, Correct It",
        });

        if (!result.isConfirmed) {
          await Swal.fire("Action Required", "Please correct the Commission Rate before saving.", "info");
          setIsSubmitting(false);
          return;
        }
      }

      // Case 2: Non-zero positive commission
      else if (commission > 0) {
        const confirmApply = await Swal.fire({
          title: "Confirm Commission Rate",
          text: `You entered a Commission Rate of ${commission}. Is this correct?`,
          icon: "question",
          showCancelButton: true,
          confirmButtonText: "Yes, It's Correct",
          cancelButtonText: "No, Change It",
        });

        if (!confirmApply.isConfirmed) {
          const resetConfirm = await Swal.fire({
            title: "Set Commission Rate to 0?",
            text: "Would you like to set the Commission Rate to 0 and save automatically?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes, Set to 0 and Save",
            cancelButtonText: "No, I'll Correct Manually",
          });

          if (resetConfirm.isConfirmed) {
            formData.Commission_Rate = 0;

            await Swal.fire({
              title: "Commission Reset",
              text: "Commission Rate has been set to 0. Record will now be saved automatically.",
              icon: "success",
              timer: 1200,
              showConfirmButton: false,
            });

            await saveTenderDetail(0);
            setIsSubmitting(false);
            return;
          } else {
            await Swal.fire("Action Required", "Please correct the Commission Rate manually before saving.", "info");
            setIsSubmitting(false);
            return;
          }
        }
      }

      // Proceed normally (either 0 or confirmed)
      await saveTenderDetail(commission);
    } catch (error) {
      console.error("Error submitting form:", error);
      Swal.fire("Error", "Failed to save Sauda detail", "error");
    } finally {
      setIsSubmitting(false);
    }
  };

  // Separate reusable save function
  const saveTenderDetail = async (commissionValue) => {
    await axios.post(`${API_URL}/add_tender_detail`, {
      detailData: {
        ...formData,
        Commission_Rate: commissionValue,
        Buyer_Quantal: parseFloat(formData.Buyer_Quantal) || 0.0,
        Sale_Rate: parseFloat(formData.Sale_Rate) || 0.0,
        tcs_amt: parseFloat(formData.tcs_amt) || 0.0,
        gst_amt: parseFloat(formData.gst_amt) || 0.0,
        tcs_rate: parseFloat(formData.tcs_rate) || 0.0,
        gst_rate: parseFloat(formData.gst_rate) || 0.0,
        Company_Code: companyCode,
        year_code: yearCode,
      },
    });

    await Swal.fire("Success!", "Sauda Updated Successfully!", "success");

    // Reset only the fields that should be cleared for new record
    // Keep Mill Code and Tender No intact
    setFormData(prev => ({
      ...initialFormState,
      // Preserve Mill Code and Tender No related fields
      Tender_No: prev.Tender_No,
      tenderid: prev.tenderid,
      Narration: prev.Narration,
      // Keep dates current
      Sauda_Date: new Date().toISOString().split("T")[0],
      Lifting_Date: new Date().toISOString().split("T")[0],
    }));

    // Reset amounts and buyer fields only
    setNetAmount("0.00");
    setBuyerName("");
    setShipToName("");
    setBrokerName("");
    setSubBrokerName("");

    // Focus buyer field for next entry
    setShouldFocusBuyer(true);
  };

  const handleBack = () => {
    navigate("/sauda-book-utility-page");
  };

  return (
    <>
      <Box
        minHeight="100vh"
        display="flex"
        justifyContent="center"
        alignItems="start"
        pt={4}
        bgcolor="#f5f5f5"
      >
        <Box mr={2} mt={1}>
          <BackButton onClick={handleBack} />
        </Box>
        <Box
          width="800px"
          bgcolor="white"
          p={3}
          borderRadius={2}
          boxShadow={2}
        >
          <Typography
            variant="h6"
            align="center"
            gutterBottom
            sx={{
              color: "black",
              fontWeight: 'bold',
              mb: 1
            }}
          >
            Sauda Book Utility
          </Typography>

          <Grid container spacing={0.5} >

            <Grid item xs={12} sm={4} display="flex" alignItems="center">
              <Typography fontWeight="bold">Mill Code :</Typography>
            </Grid>
            <Grid item xs={12} sm={8}>
              <AccountMasterHelp
                name="Mill_Code"
                CategoryCode={millCode}
                CategoryName={millName}
                onAcCodeClick={handleMillCode}
              />
            </Grid>

            <Grid item xs={12} sm={4} display="flex" alignItems="center">
              <Typography fontWeight="bold">Tender No :</Typography>
            </Grid>
            <Grid item xs={12} sm={8} >
              <Box display="flex" alignItems="center" ml={1}>
                <SaudaBookUtilityHelp
                  name="tender_no"
                  Millcode={millCode}
                  Tenderno={formData.Tender_No}
                  Tenderid={formData.tenderid}
                  onRecordDoubleClick={handleTenderSelection}
                />
                <Typography
                  variant="body2"
                  sx={{
                    color: "#0056b3",
                    fontWeight: 600,
                    fontSize: "13px",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    flex: 1
                  }}
                >
                  {tenderDisplayText}
                </Typography>
              </Box>
            </Grid>

            {[
              {
                label: "Bill To :", name: "Buyer", component: (
                  <AccountMasterHelp
                    name="Buyer"
                    CategoryCode={formData.Buyer}
                    CategoryName={buyerName}
                    onAcCodeClick={handleAccountSelect("Buyer", "buyerid")}
                    firstInputRef={buyerRef}
                  />
                )
              },
              {
                label: "Ship To :", name: "ShipTo", component: (
                  <AccountMasterHelp
                    name="ShipTo"
                    CategoryCode={formData.ShipTo}
                    CategoryName={shipToName}
                    onAcCodeClick={handleAccountSelect("ShipTo", "shiptoid")}
                  />
                )
              },
              {
                label: "Delivery Type :", name: "Delivery_Type", component: (
                  <TextField
                    select
                    size="small"
                    fullWidth
                    name="Delivery_Type"
                    value={formData.Delivery_Type}
                    onChange={handleInputChange}
                    sx={{
                      '& .MuiInputBase-root': {
                        height: '40px',
                        fontSize: '14px',
                        width: '26%',
                        marginLeft: '10px',
                      },
                      '& .MuiMenuItem-root': {
                        fontSize: '14px'
                      }
                    }}
                  >
                    <MenuItem value="N">With GST Naka Delivery</MenuItem>
                    <MenuItem value="A">Naka Delivery without GST Rate</MenuItem>
                    <MenuItem value="C">Commission</MenuItem>
                    <MenuItem value="D">DO</MenuItem>
                  </TextField>
                )
              },
              {
                label: "Broker :", name: "Buyer_Party", component: (
                  <AccountMasterHelp
                    name="Buyer_Party"
                    CategoryCode={formData.Buyer_Party}
                    CategoryName={brokerName}
                    onAcCodeClick={handleAccountSelect("Buyer_Party", "buyerpartyid")}
                  />
                )
              },
              {
                label: "Sub Broker :", name: "sub_broker", component: (
                  <AccountMasterHelp
                    name="sub_broker"
                    CategoryCode={formData.sub_broker}
                    CategoryName={subBrokerName}
                    onAcCodeClick={handleAccountSelect("sub_broker", "sbr")}
                  />
                )
              },
              // {
              //   label: "Buyer Quintal :", name: "Buyer_Quantal", component: (
              //     <TextField
              //       size="small"
              //       fullWidth
              //       type="number"
              //       name="Buyer_Quantal"
              //       autoComplete="off"
              //       value={formData.Buyer_Quantal}
              //       onChange={handleInputChange}
              //     />
              //   )
              // },

              {
                label: "Buyer Quintal :",
                name: "Buyer_Quantal",
                component: (
                  <TextField
                    size="small"
                    type="text"
                    fullWidth
                    name="Buyer_Quantal"
                    autoComplete="off"
                    value={formData.Buyer_Quantal}
                    onChange={handleInputChange}
                    onInput={(e) => {
                      e.target.value = e.target.value.replace(/[^0-9.]/g, '');
                      // Prevent multiple decimal points
                      const parts = e.target.value.split('.');
                      if (parts.length > 2) {
                        e.target.value = parts[0] + '.' + parts.slice(1).join('');
                      }
                    }}
                  />
                )
              },
              // {
              //   label: "Sale Rate :", name: "Sale_Rate", component: (
              //     <TextField
              //       size="small"
              //       type="number"
              //       fullWidth
              //       name="Sale_Rate"
              //       autoComplete="off"
              //       value={formData.Sale_Rate}
              //       onChange={handleInputChange}
              //     />
              //   )
              // },

              {
                label: "Sale Rate :",
                name: "Sale_Rate",
                component: (
                  <TextField
                    size="small"
                    type="text"
                    fullWidth
                    name="Sale_Rate"
                    autoComplete="off"
                    value={formData.Sale_Rate}
                    onChange={handleInputChange}
                    onInput={(e) => {
                      e.target.value = e.target.value.replace(/[^0-9.]/g, '');
                      // Prevent multiple decimal points
                      const parts = e.target.value.split('.');
                      if (parts.length > 2) {
                        e.target.value = parts[0] + '.' + parts.slice(1).join('');
                      }
                    }}
                  />
                )
              },
              {
                label: "Commission :", name: "Commission_Rate", component: (
                  <TextField
                    size="small"
                    type="number"
                    fullWidth
                    autoComplete="off"
                    name="Commission_Rate"
                    value={formData.Commission_Rate}
                    onChange={handleInputChange}
                    disabled
                  />
                )
              },
              {
                label: "Dates :",
                component: (
                  <Box display="flex" gap={2} alignItems="center">
                    <Box flex={1} mt={0.5}>
                      <TextField
                        type="date"
                        size="small"
                        fullWidth
                        name="Sauda_Date"
                        label="Sauda Date"
                        value={formData.Sauda_Date}
                        onChange={handleInputChange}
                        InputLabelProps={{ shrink: true }}
                      />
                    </Box>
                    <Box flex={1} mt={0.5}>
                      <TextField
                        type="date"
                        size="small"
                        fullWidth
                        name="Lifting_Date"
                        label="Payment Date"
                        value={formData.Lifting_Date}
                        onChange={handleInputChange}
                        InputLabelProps={{ shrink: true }}
                      />
                    </Box>
                  </Box>
                )
              },
              {
                label: "Narration :", name: "Narration", component: (
                  <TextField
                    size="small"
                    fullWidth
                    name="Narration"
                    value={formData.Narration}
                    onChange={handleInputChange}
                    multiline
                    rows={2}
                  />
                )
              },
            ].map((item, index) => (
              <React.Fragment key={item.name}>
                <Grid item xs={12} sm={4} display="flex" alignItems="center">
                  <Typography fontWeight="bold">{item.label}</Typography>
                </Grid>
                <Grid item xs={12} sm={8}>
                  {item.component}
                </Grid>
              </React.Fragment>
            ))}

            <Grid item xs={12} sm={4} display="flex" alignItems="center">
              <Typography fontWeight="bold">GST Amount :</Typography>
            </Grid>
            <Grid item xs={6} sm={4} mt={1}>
              <TextField
                label="GST Rate"
                type="number"
                autoCapitalize="off"
                size="small"
                fullWidth
                name="gst_rate"
                value={formData.gst_rate}
                onChange={handleInputChange}
              />
            </Grid>
            <Grid item xs={6} sm={4} mt={1}>
              <TextField
                label="GST Amount"
                type="number"
                autoCapitalize="off"
                size="small"
                fullWidth
                value={formData.gst_amt}
                InputProps={{ readOnly: true }}
              />
            </Grid>

            <Grid item xs={12} sm={4} display="flex" alignItems="center">
              <Typography fontWeight="bold">TCS Amount :</Typography>
            </Grid>
            <Grid item xs={6} sm={4} mt={1}>
              <TextField
                label="TCS Rate"
                type="number"
                autoCapitalize="off"
                size="small"
                fullWidth
                name="tcs_rate"
                value={formData.tcs_rate}
                onChange={handleInputChange}
              />
            </Grid>
            <Grid item xs={6} sm={4} mt={1}>
              <TextField
                label="TCS Amount"
                type="number"
                autoCapitalize="off"
                size="small"
                fullWidth
                value={formData.tcs_amt}
                InputProps={{ readOnly: true }}
              />
            </Grid>

            <Grid item xs={12} sm={4} display="flex" alignItems="center">
              <Typography fontWeight="bold">Net Amount :</Typography>
            </Grid>
            <Grid item xs={12} sm={8}>
              <TextField
                size="small"
                type="number"
                autoCapitalize="off"
                fullWidth
                value={netAmount}
                InputProps={{
                  readOnly: true,
                  sx: { fontWeight: 'bold', fontSize: '1rem' }
                }}
              />
            </Grid>

            <Grid item xs={12} sx={{ mt: 2 }}>
              <Button
                variant="contained"
                fullWidth
                onClick={handleSubmit}
                disabled={isSubmitting}
                sx={{
                  width: '150px',
                  height: '36px',
                  fontSize: '0.875rem',
                  fontWeight: 'bold',
                  padding: '6px 12px',
                  backgroundColor: isSubmitting ? '#9e9e9e' : undefined,
                  cursor: isSubmitting ? 'not-allowed' : 'pointer',
                }}
              >
                {isSubmitting ? 'Saving...' : 'Update'}
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </>
  );
};

export default SaudaBookUtility;

